var map = {
	"./icon-5D-items-selected.svg": "47b7",
	"./icon-arrow-left.svg": "6361",
	"./icon-arrow-right.svg": "8e62",
	"./icon-close.svg": "841d",
	"./icon-download-appstore.svg": "dd9b",
	"./icon-download-playstore.svg": "4c4b",
	"./icon-info.svg": "83abd",
	"./icon-lang-en.svg": "8118",
	"./icon-lang-nl.svg": "e2bf",
	"./icon-link.svg": "60ab",
	"./icon-message.svg": "a8bd",
	"./icon-next-10s.svg": "5490",
	"./icon-placeholder.svg": "aac6",
	"./icon-prev-10s.svg": "99e8",
	"./icon-share.svg": "e79c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ad36";